var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 2.138c-3.91-.61-5.72.71-6.34 4.62l-.74 4.69c-.4 2.56.02 4.22 1.47 5.23.76.54 1.8.9 3.15 1.11l4.69.74c3.91.61 5.72-.71 6.34-4.62l.73-4.69c.12-.77.17-1.46.13-2.07-.13-2.5-1.6-3.78-4.74-4.27l-4.69-.74zm-3.08 5.1c0-1.17.95-2.12 2.12-2.12 1.16 0 2.11.95 2.11 2.12 0 1.16-.95 2.11-2.11 2.11-1.17 0-2.12-.95-2.12-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17.979c-1.25 3.76-3.25 4.76-7.01 3.51l-4.51-1.5c-1.41-.47-2.43-1.05-3.09-1.78.63.25 1.36.44 2.19.57l4.7.74c.64.1 1.24.15 1.8.15 3.3 0 5.07-1.78 5.68-5.61l.73-4.69c.1-.58.14-1.09.14-1.56 1.52 1.25 1.74 3.03.87 5.66l-1.5 4.51z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldClipboard);
export default __webpack_public_path__ + "static/media/vuesax-bold-clipboard.77cc55edb3ce3dfedf76988b5163c3d1.svg";
export { ForwardRef as ReactComponent };